import { render, staticRenderFns } from "./ButtonsWithOrWrapper.vue?vue&type=template&id=19380886&scoped=true"
import script from "./ButtonsWithOrWrapper.vue?vue&type=script&lang=js"
export * from "./ButtonsWithOrWrapper.vue?vue&type=script&lang=js"
import style0 from "./ButtonsWithOrWrapper.vue?vue&type=style&index=0&id=19380886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19380886",
  null
  
)

export default component.exports